module.exports = __webpack_public_path__ + "static/media/simbolo.7fa02e36.png";